import React from "react";
import ReactECharts from "echarts-for-react";

const DonutChartWithGap = ({ value, labelText, color }) => {
  const totalValue = 100; // The total percentage is always 100
  const remainingValue = totalValue - value; // Calculate the remaining percentage
  const gapValue = 2; // Define a small gap between the segments

  // Adjust the filled and remaining values by subtracting half of the gap for each side
  let filledValue = value - gapValue;
  let remainingValueAdjusted = remainingValue - gapValue;

  // If the value is 100, we don't want to adjust anything
  if (value === 100) {
    filledValue = value;
    remainingValueAdjusted = remainingValue;
  }

  const chartSize = 80; // Fixed size for the chart

  const option = {
    animation: false,
    tooltip: {
      show: false, // Disable the tooltip completely
    },
    legend: {
      show: false, // Hide the legend
    },
    series: [
      {
        name: "Progress",
        type: "pie",
        radius: ["40%", "70%"], // Defines the donut thickness
        avoidLabelOverlap: false,
        label: {
          show: false, // Hide the label text inside the donut
          position: "center",
        },
        emphasis: {
          label: {
            show: false,
            fontSize: 40,
            fontWeight: "bold",
          },
          itemStyle: {
            shadowBlur: 0,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1, // Keep the segment visible, no zoom
          },
          label: {
            show: false, // Hide the label when hovering
          },
        },
        labelLine: {
          show: false, // Hide the label line
        },
        itemStyle: {
          borderWidth: 0, // No border thickness
          borderColor: "transparent", // No border color
        },
        data: [
          {
            value: gapValue, // Invisible gap at the start
            name: "Gap Start",
            itemStyle: {
              color: "transparent", // Invisible gap at the start
            },
          },
          {
            value: filledValue, // Filled portion
            name: "Filled",
            itemStyle: {
              color: color, // Green for the filled portion
            },
          },
          {
            value: gapValue, // Invisible gap at the end
            name: "Gap End",
            itemStyle: {
              color: "transparent", // Invisible gap at the end
            },
          },
          {
            value: remainingValueAdjusted, // Remaining portion
            name: "Remaining",
            itemStyle: {
              color: "#e0e0e0", // Light gray for the remaining portion
            },
          },
        ],
      },
    ],
  };

  return (
    <div
      style={{
        width: `${chartSize}px`,
        height: `${chartSize}px`,
        // margin: "auto",
      }}
    >
      <ReactECharts option={option} style={{ width: "100%", height: "100%" }} />
    </div>
  );
};

export default DonutChartWithGap;
